import { z } from 'zod'

export const AffiliateCommissionChangeSourceSchema = z.enum([
  'PRODUCT_DEFAULT',
  'INDIVIDUAL_OVERRIDE',
])
export type AffiliateCommissionChangeSource = z.infer<typeof AffiliateCommissionChangeSourceSchema>

export const AffiliateCommissionChangeSchema = z.object({
  id: z.string(),
  productId: z.string(),
  agreementId: z.string().optional(),
  previousPercentage: z.string(),
  newPercentage: z.string(),
  changeSource: AffiliateCommissionChangeSourceSchema,
  changedByUserId: z.string(),
  affectedAgreementsCount: z.number().int().nonnegative().optional(),
  createdAt: z.string(),
})
export type AffiliateCommissionChange = z.infer<typeof AffiliateCommissionChangeSchema>
